module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2016/july-7930a03aad3f03ae43471c38a1760763.png";